const StepFragment = `
    id
`

export default StepFragment
